import { render } from "./CategoryPromotion.vue?vue&type=template&id=323e9b2b"
import script from "./CategoryPromotion.vue?vue&type=script&lang=js"
export * from "./CategoryPromotion.vue?vue&type=script&lang=js"

import "./CategoryPromotion.vue?vue&type=style&index=0&id=323e9b2b&lang=css"

import exportComponent from "F:\\admin_om\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__